module.exports = __webpack_public_path__ + "img/flight-icon.5fe82825.svg";